import FilestackClient from 'lib/filestack'

class FileUploader {
  constructor(options) {
    this.inputBlob = options.blob
    this.onUpdate = options.onUpdate
    this.onSuccess = options.onSuccess
    this.fileTypes = options.fileTypes || []
    this.uploadedBlob = null
    this.progress = 0
    this.state = 'waiting'
    this.filestack = new FilestackClient({
      getPolicy: options.getPolicy,
    })
  }

  async startUpload() {
    if (!this.blobIsValid(this.inputBlob)) {
      this.state = 'rejected'
      return Promise.reject(false)
    }

    this.state = 'uploading'

    const blob = await this.filestack.storeFile(this.inputBlob, (progress) => {
      this.setProgress(progress)
    })

    if (!this.blobIsValid(blob)) {
      this.state = 'rejected'
      return Promise.reject(false)
    }

    this.completeUpload(blob)

    return Promise.resolve(true)
  }

  async removeUpload() {
    if (this.uploadedBlob) {
      return this.filestack.removeFile(this.uploadedBlob)
    }

    return Promise.resolve(true)
  }

  blobIsValid(blob) {
    const mimetype = blob.mimetype || blob.type
    if (!mimetype) return false
    return this.fileTypes.includes(mimetype)
  }

  completeUpload(blob) {
    this.uploadedBlob = blob
    this.progress = 100
    this.state = 'uploaded'
    if (this.onUpdate) this.onUpdate(this)
    if (this.onSuccess) this.onSuccess(this)
  }

  setProgress(progress) {
    this.progress = progress
    if (this.onUpdate) this.onUpdate(this)
  }
}

export default FileUploader
